import { binarySearch } from "../algorithms/binary-search";
import { lerp } from "./functions";

function lerpDataPointsY(a:[number,number], b:[number,number], x:number){
	const xDiff=b[0]-a[0];
	if(xDiff===0)
		return lerp(a[1],b[1],0.5);
	return lerp(a[1],b[1],(x-a[0])/xDiff);
}

function lerpDataPoints(a:[number,number], b:[number,number], x:number):[number,number]{
	return [
		x,
		lerpDataPointsY(a,b,x),
	];
}

export class DataPoints{
	public constructor(
		public data:[number,number][]=[] //expected to be in assenting x order (first value)
	){
	}

	public sort(){
		this.data.sort((a,b)=>a[0]-b[0]);
		return this;
	}

	public bruteForceAt(x:number){
		//brute force, for reference
		const {data}=this;
		if(!data.length)
			return undefined;
		if(x<data[0][0])
			return data[0][1];
		for(let i=1;i<data.length;++i){
			const b=data[i];
			if(x<b[0]){
				const a=data[i-1];
				return lerpDataPointsY(a,b,x);
			}
		}
		return data.at(-1)![1];
	}

	public at(x:number){
		const [a,b]=binarySearch(this.data,v=>v[0],x);
		if(a===null){
			if(b===null)
				return undefined;
			return b[1];
		}
		if(b===null)
			return a[1];
		return lerpDataPointsY(a,b,x);
	}

	public sample(sampleRate:number){
		const {data}=this;
		if(!data.length)
			return [];

		const samples:[number,number][][]=[[data[0]]];
		let sx=data[0][0]+sampleRate;
		for(let i=1;i<data.length;++i){
			const a=data[i-1];
			const b=data[i];
			while(sx<b[0]){
				const p=lerpDataPoints(a,b,sx);
				samples.at(-1)!.push(p);
				samples.push([p]);
				sx+=sampleRate;
			}
			samples.at(-1)!.push(b);
		}

		return samples.map(data=>{
			if(!data.length)
				return 0;
			if(data.length===1)
				return data[0][1];
			let area=0;
			for(const [a,b] of data.pairs())
				area+=(b[0]-a[0])*(b[1]+a[1])/2;
			return area/(data.at(-1)![0]-data.at(0)![0]);
		});
	}
}